import {configureStore} from '@reduxjs/toolkit'
import {logger} from 'tizra'
import createRootReducer from './reducer'

const log = logger('quickstart/store')

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const loggerMiddleware = store => next => action => next(log.tap(action))

export const createStore = options =>
  configureStore({
    reducer: createRootReducer(options),
    middleware: [loggerMiddleware],
  })
